import React, { useState, useEffect } from 'react'
import NewsletterCard from '@/components/NewsletterCard'

const Newsletters = ({ newsletters, onEmailUpdate }) => {
  const onSubscribe = payload => {
    console.log('onSubscribe', payload)
  }
  return (
    <div className="grid gap-3 px-2 py-8 sm:grid-cols-2 sm:gap-8 sm:py-8">
      {newsletters &&
        newsletters.map((newsletter, index) => (
          <NewsletterCard
            key={index}
            newsletter={newsletter}
            onSubscribe={onSubscribe}
          />
        ))}
    </div>
  )
}

export default Newsletters
